import React from "react";
import './QuestionBoxFeedback.css'
import Button from "./Button";
import TitleText from "./TitleText";

function QuestionBoxFeedback({ isSubmitEnabled, onSubmit }) {
    return (
        <div className="question-box-feedback">
            <TitleText
                text={"Complete and submit the feeback to interact again with the assistant"}
            />
            { isSubmitEnabled &&
                <Button
                    text={"Submit"}
                    onClick={onSubmit}
                />
            }
        </div>
    );
}

export default QuestionBoxFeedback;

